import { render } from "./_admin-new.vue?vue&type=template&id=22e38d3e&lang=pug"
import script from "./_admin-new.vue?vue&type=script&lang=js"
export * from "./_admin-new.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__